import React from 'react';
import { motion } from 'framer-motion';
import { Image, Clock, FileText } from 'lucide-react';
export function ReportSection() {
  const bullets = [{
    icon: <Image className="w-4 h-4 text-blue-600" data-id="element-229" />,
    text: 'Fotos con contexto'
  }, {
    icon: <Clock className="w-4 h-4 text-blue-600" data-id="element-230" />,
    text: 'Orden cronológico automático'
  }, {
    icon: <FileText className="w-4 h-4 text-blue-600" data-id="element-231" />,
    text: 'PDF listo para enviar'
  }];
  return <section className="py-16 sm:py-24 bg-white" data-id="element-232">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-233">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-gray-900 leading-[1.15] tracking-tight mb-5 sm:mb-6 max-w-3xl mx-auto" data-id="element-234">
          El informe no se arma solo con fotos.
          <span className="block text-blue-600 mt-2" data-id="element-235">
            Se arma con evidencia.
          </span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto mb-10 sm:mb-12 leading-relaxed" data-id="element-236">
          Selecciona imágenes y genera informes profesionales en minutos, sin
          Word y sin perder horas ordenando archivos.
        </motion.p>

        <div className="flex flex-wrap justify-center gap-2.5 sm:gap-3 max-w-2xl mx-auto" data-id="element-237">
          {bullets.map((bullet, index) => <motion.div key={bullet.text} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.15 + index * 0.08
        }} className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-blue-50 border border-blue-100" data-id="element-238">
              {bullet.icon}
              <span className="text-sm font-semibold text-blue-700" data-id="element-239">
                {bullet.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}